
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsOfService() {
  return (
    <div className="container max-w-4xl mx-auto py-8">
      <div className="mb-8">
        <Button
          variant="ghost"
          size="sm"
          className="mb-4"
          asChild
        >
          <Link to="/" className="flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            <span className="font-serif">Back to Home</span>
          </Link>
        </Button>
        
        <h1 className="text-3xl font-title text-primary mb-6">Terms of Service</h1>
        
        <div className="prose prose-slate max-w-none font-body">
          <p className="text-muted-foreground text-sm mb-6">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing or using the NWSISD CEU Program Portal (the "Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">2. Description of Service</h2>
          <p>
            The Service provides a platform for educators to browse, register for, and track continuing education courses and certificates provided by Northwest Suburban Integration School District ("NWSISD").
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">3. User Accounts</h2>
          <p>
            To access certain features of the Service, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to provide accurate and complete information when creating your account and to update your information as necessary.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">4. Course Registration and Attendance</h2>
          <p>
            By registering for a course, you agree to:
          </p>
          <ul className="list-disc pl-6 space-y-2 my-4">
            <li>Provide accurate registration information.</li>
            <li>Attend the course as scheduled or cancel your registration in a timely manner.</li>
            <li>Comply with any course-specific requirements or policies.</li>
          </ul>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">5. Intellectual Property</h2>
          <p>
            All content provided through the Service, including but not limited to text, graphics, logos, images, and software, is the property of NWSISD or its content suppliers and is protected by copyright and other intellectual property laws. You may not use, reproduce, distribute, or create derivative works from this content without explicit permission.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">6. User Conduct</h2>
          <p>
            You agree not to:
          </p>
          <ul className="list-disc pl-6 space-y-2 my-4">
            <li>Use the Service for any unlawful purpose or in violation of these Terms.</li>
            <li>Attempt to gain unauthorized access to any part of the Service or any system or network connected to the Service.</li>
            <li>Interfere with the proper working of the Service.</li>
            <li>Share your account credentials with others or allow others to use your account.</li>
          </ul>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">7. Disclaimer of Warranties</h2>
          <p>
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. NWSISD DOES NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">8. Limitation of Liability</h2>
          <p>
            NWSISD SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATING TO YOUR USE OF THE SERVICE.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">9. Changes to Terms</h2>
          <p>
            NWSISD reserves the right to modify these Terms at any time. We will provide notice of significant changes by posting the updated Terms on this page and updating the "Last Updated" date.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">10. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p className="mt-2">
            Northwest Suburban Integration School District<br />
            Email: info@nwsisd.org
          </p>
        </div>
      </div>
    </div>
  );
}
